/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateCardViewStorePathParams, CandidateCardViewStoreResponse } from '../types/CandidateCardViewStore'

/**
 * POST /candidates/:candidate/card-views
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateCardViewController.php CandidateCardViewController::store
 */
export async function candidateCardViewStore(
	candidate: CandidateCardViewStorePathParams['candidate'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateCardViewStoreResponse>> {
	return axiosInstance.post(`/candidates/${candidate}/card-views`, undefined, config)
}
